import { h } from 'preact';
import * as BaseComp from 'components/bolt/gallery/gallery.js';
import Store from 'store/store';
import 'store/bolt/gallery';

import HTML from 'components/core/html/html';
import Link from 'components/bolt/link/link';
import VideoPlayer from 'components/bolt/videos/player';
import Transition from 'components/core/transition/transition';

import { accessNested, joinClasses, triggerAnim, sortObjectByOrder } from 'utils/utils';
import { pages } from 'pages/bolt_pages';
import { getCopy } from 'utils/copy';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';
import { getDynamicData } from 'utils/bolt/dynamicData';
import slugify from 'utils/slugify';
import { findInVNode } from 'utils/vnode';

import s from 'components/bolt/gallery/gallery.sss';

const Quote = (props) => {
	return (
		<svg width="37" height="31" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<mask id="a" maskUnits="userSpaceOnUse" x="0" y="0" width="37" height="31" fill="#000">
				<path fill="#fff" d="M0 0h37v31H0z" />
				<path d="M16.766 1.156v7.032h-1.922c-1.625 0-2.906.546-3.844 1.64-.906 1.063-1.36 2.578-1.36 4.547v3.14L7.72 15.595h9.047v14.39H1.953V14.797c0-4.563 1.172-7.969 3.516-10.219 2.375-2.281 5.687-3.422 9.937-3.422h1.36zm19.125 0v7.032h-1.922c-1.625 0-2.907.546-3.844 1.64-.906 1.063-1.36 2.578-1.36 4.547v3.14l-1.921-1.921h9.047v14.39H21.078V14.797c0-4.563 1.172-7.969 3.516-10.219 2.375-2.281 5.687-3.422 9.937-3.422h1.36z" />
			</mask>
			<path d="M16.766 1.156h1v-1h-1v1zm0 7.032v1h1v-1h-1zM11 9.828l-.76-.65v.001l.76.65zm-1.36 7.688-.706.707 1.707 1.707v-2.414h-1zM7.72 15.594v-1H5.305L7.012 16.3l.707-.707zm9.047 0h1v-1h-1v1zm0 14.39v1h1v-1h-1zm-14.813 0h-1v1h1v-1zM5.47 4.578l.692.722-.692-.722zM35.89 1.156h1v-1h-1v1zm0 7.032v1h1v-1h-1zm-5.766 1.64-.76-.65v.001l.76.65zm-1.36 7.688-.707.707 1.708 1.707v-2.414h-1zm-1.921-1.922v-1h-2.415l1.708 1.707.707-.707zm9.047 0h1v-1h-1v1zm0 14.39v1h1v-1h-1zm-14.813 0h-1v1h1v-1zm3.516-25.406.692.722-.692-.722zm-7.828-3.422h-1v7.032h2V1.155h-1zm0 7.032v-1h-1.922v2h1.922v-1zm-1.922 0v-1c-1.875 0-3.45.644-4.603 1.99l.759.65.76.65c.721-.841 1.709-1.29 3.084-1.29v-1zM11 9.828l-.76-.649c-1.114 1.306-1.6 3.086-1.6 5.196h2c0-1.827.422-3.078 1.12-3.898L11 9.828zm-1.36 4.547h-1v3.14h2v-3.14h-1zm0 3.14.708-.707-1.922-1.921-.707.707-.707.707 1.922 1.922.707-.707zM7.72 15.595v1h9.047v-2H7.719v1zm9.047 0h-1v14.39h2v-14.39h-1zm0 14.39v-1H1.953v2h14.813v-1zm-14.813 0h1V14.797h-2v15.187h1zm0-15.187h1c0-4.403 1.13-7.502 3.208-9.497l-.692-.722-.693-.721C2.168 6.36.953 10.074.953 14.797h1zM5.47 4.578l.692.721c2.14-2.054 5.176-3.143 9.245-3.143v-2c-4.43 0-8.02 1.193-10.63 3.7l.693.722zm9.937-3.422v1h1.36v-2h-1.36v1zm20.485 0h-1v7.032h2V1.155h-1zm0 7.032v-1h-1.922v2h1.922v-1zm-1.922 0v-1c-1.875 0-3.45.644-4.603 1.99l.759.65.76.65c.721-.841 1.709-1.29 3.084-1.29v-1zm-3.844 1.64-.76-.649c-1.114 1.306-1.6 3.086-1.6 5.196h2c0-1.827.422-3.078 1.12-3.898l-.76-.649zm-1.36 4.547h-1v3.14h2v-3.14h-1zm0 3.14.708-.707-1.922-1.921-.707.707-.707.707 1.921 1.922.708-.707zm-1.921-1.921v1h9.047v-2h-9.047v1zm9.047 0h-1v14.39h2v-14.39h-1zm0 14.39v-1H21.078v2h14.813v-1zm-14.813 0h1V14.797h-2v15.187h1zm0-15.187h1c0-4.403 1.13-7.502 3.208-9.497l-.692-.722-.693-.721c-2.608 2.504-3.823 6.217-3.823 10.94h1zm3.516-10.219.692.721c2.14-2.054 5.176-3.143 9.245-3.143v-2c-4.43 0-8.02 1.193-10.63 3.7l.693.722zm9.937-3.422v1h1.36v-2h-1.36v1z" fill="#fff" mask="url(#a)" />
		</svg>
	);
};

// const TOUCH_SLOP = 8;
const TRANSITION_DURATION = 1000;

export default class Gallery extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();

		if (this.props.appData?.options?.cmsManaged) {
			await this.loadCustomData();
		}

		observeScroll(this.base, { once: true });

		const activeImage = this.getActiveImage();

		if (this.isASpotlightPage) {
			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'spotlight-view',
				label: activeImage.name
			});
		} else {
			//gallery
			Store.emit('CUSTOM_EVENT', {
				category:  this.props.id,
				action: 'gallery-view',
				label: activeImage?.title + '_' + activeImage?.name
			});
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount?.();

		unobserveScroll(this.base);
	}

	async loadCustomData() {
		const { id } = this.props;
		let galleryData = {};
		let dynamicData = null;

		switch (id) {
			case 'filmmakersStrategiesSpotlight':
				dynamicData = await getDynamicData('filmmakers-strategies');
				const spotlightGallery = dynamicData.gallerySpotlight || [];

				if (!spotlightGallery?.length) return;

				galleryData = spotlightGallery.reduce((acc, item, i) => {
					const hasMedia = item.file && item.file.length;
					const hasText = item.name?.trim() || item.message?.trim() || item.annotation?.trim();
					if (!hasMedia && !hasText) return acc;
					if (!item.id) return acc;

					acc[item.id] = {
						order: i + 1,
						name: item.name,
						desktopSrc: item.file,
						tabletSrc: item.file,
						mobileSrc: item.file,
						videoSrc: null,
						annotation: item.annotation,
						alt: item.alt || '',
						message: item.message || '',
						role: item.role || '',
					};
					return acc;
				}, {});
				break;

			case 'filmmakersStrategiesGallery':
				dynamicData = await getDynamicData('filmmakers-strategies');
				const videoGallery = dynamicData.gallery;

				if (!videoGallery?.length) return;

				galleryData = videoGallery.reduce((acc, video, i) => {
					if (!video.id) return acc;

					const isVideo = video.file?.endsWith('.mp4') || video.file?.endsWith('.webm');

					acc[video.id] = {
						order: i + 1,
						name: video.name || `video-${i + 1}`,
						desktopSrc: isVideo ? null : video.file,
						tabletSrc: isVideo ? null : video.file,
						mobileSrc: isVideo ? null : video.file,
						videoSrc: isVideo ? video.file : null,
						title: video.header || '',
						description: video.description || '',
						alt: video.alt || '',
					};
					return acc;
				}, {});
				break;

			case 'belowTheLineGallery':
				dynamicData = await getDynamicData('below-the-line');
				const aboutGallery = dynamicData.gallery;

				if (!aboutGallery?.length) return;

				galleryData = aboutGallery.reduce((acc, item, i) => {
					if (!item.id) return acc;

					const isVideo = item.file?.endsWith('.mp4') || item.file?.endsWith('.webm');

					acc[item.id] = {
						order: i + 1,
						name: item.name || `item-${i + 1}`,
						desktopSrc: !isVideo ? item.file : null,
						tabletSrc: !isVideo ? item.file : null,
						mobileSrc: !isVideo ? item.file : null,
						videoSrc: isVideo ? item.file : null,
						title: item.header || '',
						description: item.description || '',
						alt: item.alt || '',
					};

					return acc;
				}, {});
				break;

			case 'composersInitiativeSpotlight':
				dynamicData = await getDynamicData('composers-initiative');
				const gallerySpotlight = dynamicData.gallerySpotlight || [];

				if (!gallerySpotlight?.length) return;

				galleryData = gallerySpotlight.reduce((acc, item, i) => {
					const hasMedia = item.file && item.file.length;
					const hasText = item.name?.trim() || item.message?.trim() || item.annotation?.trim();
					if (!hasMedia && !hasText) return acc;
					if (!item.id) return acc;

					acc[item.id] = {
						order: i + 1,
						name: item.name,
						desktopSrc: item.file,
						tabletSrc: item.file,
						mobileSrc: item.file,
						videoSrc: null,
						annotation: item.annotation,
						alt: item.alt || '',
						message: item.message || '',
						role: item.role || '',
					};
					return acc;
				}, {});
				break;

			case 'composersInitiativeGallery':
				dynamicData = await getDynamicData('composers-initiative');
				const composerGallery = dynamicData.gallery;

				if (!composerGallery?.length) return;

				galleryData = composerGallery.reduce((acc, video, i) => {
					if (!video.id) return acc;

					const isVideo = video.file?.endsWith('.mp4');

					acc[video.id] = {
						order: i + 1,
						name: video.name || `video-${i + 1}`,
						desktopSrc: isVideo ? null : video.file,
						tabletSrc: isVideo ? null : video.file,
						mobileSrc: isVideo ? null : video.file,
						videoSrc: isVideo ? video.file : null,
						title: video.header || '',
						description: video.description || '',
						alt: video.alt || '',
					};
					return acc;
				}, {});
				break;

			default:
				console.warn('No dynamic data handler for gallery id:', id);
				return;
		}

		const pageData = this.props.pageData || this.props.appData.pages[this.props.id]?.data;
		const galleryHash = pageData?.hash;
		const pageName = this.props.appData?.pages?.[this.props.id]?.name;
		const pageIdentifier =
        this.props.appData?.copy?.baseCopy?.[pageName] ||
        (pageName?.startsWith('$') ? null : pageName) ||
        this.props.id;

		const galleryDataArray = sortObjectByOrder(galleryData, (value, key) => ({
			...value,
			fileName: value?.pdfSrc?.split('/')?.pop(),
			key,
			trackKey: slugify(pageIdentifier + '-' + key),
			altKey: galleryHash && slugify(galleryHash + '-' + key),
		}));

		const galleryTitle = dynamicData.heading?.text;
		this.setState({ images: galleryDataArray, galleryTitle });

		this.unpackYoutubePlaylists(galleryDataArray);

		this.setState({ images: galleryDataArray });
	}

	get isASpotlightPage() {
		return this.props.id.toLowerCase().includes('spotlight') || false;
	}

	get isAGalleryPage() {
		return this.props.id.toLowerCase().includes('gallery') || false;
	}

	onDragStart(e) {
		if (this.isASpotlightPage) {
			return;
		}
	}
	onDrag(e) {
		if (this.isASpotlightPage) {
			return;
		}
	}
	onDragEnd(e) {
		if (this.isASpotlightPage) {
			return;
		}
	}

	changeImageRelative(offset, opts) {
		if (this.isASpotlightPage) {
			const bottom = document.querySelector(`.${s.bottom}`);
			triggerAnim(bottom, s.fadeQuoteIcon);
		}
		super.changeImageRelative(offset, opts);
		const activeImage = this.getActiveImage();

		if (this.isASpotlightPage) {
			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'spotlight-view',
				label: activeImage.name
			});

			const bottom = document.querySelector(`.${s.bottom}`);
			triggerAnim(bottom, s.fadeQuoteIcon);
		} else if (this.isAGalleryPage) {
			//gallery
			Store.emit('CUSTOM_EVENT', {
				category: this.props.id,
				action: 'gallery-view',
				label: activeImage?.title + '_' + activeImage?.name
			});
		}
	}

	renderImage() {
		const { loading, swipeToChange, direction } = this.state;
		const activeImage = this.getActiveImage();
		const image = this.getSrc(activeImage);
		const transitionDuration = swipeToChange ? 0 : TRANSITION_DURATION;
		const alt = activeImage.alt && activeImage.alt.charAt(0) === '$' ? getCopy(activeImage.alt) : activeImage.alt || '';

		let elem = (
			<Transition
				duration={transitionDuration}
				class={joinClasses(s.imageTransitionContainer, direction && s[`${direction == -1 ? 'left' : 'right'}SlideTransition`])}
				enteringClass={s.imageTransitionEntering}
				visibleClass={s.imageTransitionVisible}
				leavingClass={s.imageTransitionLeaving}
			>
				<div>
					<img
						class={joinClasses(s.activeImage, loading && s.loading, activeImage.path && s.clickable)}
						src={image}
						alt={alt}
						ariaLabel={alt}
						onLoad={() => this.imageLoaded(image)}
						ref={$ref => this.$galleryImage = $ref}
						key={`image-${image}`}
						onMouseDown={this.onDragStart}
						onTouchStart={this.onDragStart}
						onMouseMove={this.onDrag}
						onTouchMove={this.onDrag}
						onMouseUp={this.onDragEnd}
						onTouchEnd={this.onDragEnd}
						onClick={!!activeImage.path && (() => this.triggerImageClick(activeImage.path, activeImage.sameWindow))}
					/>
				</div>
			</Transition>
		);
		if (activeImage.path?.startsWith('http')) {
			return (
				<Link href={activeImage.path} target={activeImage.sameWindow ? '_self' : '_blank'}>
					{elem}
				</Link>
			);
		}
		return elem;
	}

	renderVideo() {
		const { loading, playing } = this.state;
		const video = this.getActiveImage();
		const isYoutube = video.youtubeId;
		const pageId = this.props?.id;
		const pageData = this.props?.appData?.pages[pageId]?.data || {};

		return (
			<div
				class={joinClasses(s.videoContainer, loading && s.loading)}
				ref={(ref) => (this.videoContainer = ref)}
				onMouseDown={!isYoutube && this.onDragStart}
				onTouchStart={!isYoutube && this.onDragStart}
				onMouseMove={!isYoutube && this.onDrag}
				onTouchMove={!isYoutube && this.onDrag}
				onMouseUp={!isYoutube && this.onDragEnd}
				onTouchEnd={!isYoutube && this.onDragEnd}
			>
				<VideoPlayer
					ref={(ref) => (this.videoPlayer = ref)}
					activeVideo={video}
					onPlay={() => this.togglePlaying(true)}
					onPause={() => this.togglePlaying(false)}
					noAutoplay={video.noAutoplay}
					onLoaded={this.onLoadedHandler}
					onEnded={() => this.onEndedHandler(video)}
					overrideStyles
					muted={pageData.autoMuteVideos}
					pageId={pageId}

				/>
				{isYoutube && (
					<div
						onMouseDown={this.onDragStart}
						onTouchStart={this.onDragStart}
						onMouseMove={this.onDrag}
						onTouchMove={this.onDrag}
						onMouseUp={this.onDragEnd}
						onTouchEnd={this.onDragEnd}
						onClick={this.videoClickHandler}
						class={s.touchOverlay}
						style={{ pointerEvents: playing ? 'none' : 'all' }}
					/>
				)}
			</div>
		);
	}

	renderSpotlight(props) {
		let path = `appData.pages.${props.id}.data`;
		if (props.isEmbeded) {
			path = `${path}.gallery`;
		}
		const data = props.pageData || accessNested(props, path) || {};
		const { images, loading, swipeToChange, direction } = this.state;
		const isDesktopSize = accessNested(props, 'client.dimensions.width', 0) >= 1024;
		const activeImage = this.getActiveImage();
		const isVideo =
			activeImage.videoSrc ||
			activeImage.vimeoId ||
			activeImage.youtubeId ||
			activeImage.youtubeId ||
			activeImage.disneySrc ||
			activeImage.youtubePlaylistId;
		const galleryTitle = this.state.galleryTitle || data.title;
		const canDownloadAll = data.downloadAll;
		const customDownloadAll = data.customDownloadAll || {};
		const canDownloadSingle = data.downloadSingle;
		const canShare = data.share;
		const galleryDescription = data.description;
		const hideArrowsMobile = data.hideArrowsMobile || props.isMiniGallery;
		const hideArrowsDesktop = data.hideArrowsDesktop || props.isMiniGallery;
		const isMobile = accessNested(props, 'client.deviceSize', 'mobile') === 'mobile';
		const shareMetaOverrides = data.shareMetaOverrides;
		const shouldShowControls = images.length > 1;
		const showMobileArrows = shouldShowControls && !isDesktopSize;
		const active = props.store?.header?.activeSection === props.id;
		const fontStyles = accessNested(props, 'appData.styling.fontVariables', {});
		const hasGif = this.state.images.map((image) => this.getSrc(image)).find((src) => src && src.endsWith('gif'));
		const isIOS = accessNested(props, 'client.isIOS', false);
		const isSafari = accessNested(props, 'client.isSafari', false);
		const iosChromeGif = isIOS && !isSafari && hasGif;
		const isSection = accessNested(this.props, ['store', 'appData', 'pages', props.id, 'section']);
		const dedicatedPage = pages[props.id] && !isSection;
		const hasDownloads = (canDownloadAll || canDownloadSingle) && !iosChromeGif;
		const hasExtraActions = hasDownloads || canShare;

		const transitionDuration = swipeToChange ? 0 : TRANSITION_DURATION;

		return (
			<div
				class={joinClasses({
					s,
					container: true,
					active: active,
					hasDownloads: hasDownloads,
					canShare: canShare,
					includeTopArrows: !isDesktopSize && !hideArrowsMobile,
					isEmbeded: props.isEmbeded,
					dedicatedPage,
					miniGallery: props.isMiniGallery,
				})}
				data-section={props.id}
				ref={($ref) => (this.$container = $ref)}
			>
				{this.renderBgContent()}
				<div class={s.inner} key="inner">
					{galleryTitle && <HTML tag="h1" onClickCapture={this.onClick} markdown content={galleryTitle} class={joinClasses(s.galleryTitle, 'h3')} />}
					{galleryDescription && (
						<HTML
							tag="h2"
							onClickCapture={this.onMarkdownClickCapture}
							markdown
							content={galleryDescription}
							class={joinClasses(s.galleryDescription, 'xlarge', isMobile && !hideArrowsMobile && s.withMobileArrows)}
						/>
					)}
					<div class={joinClasses(s.imageWrapper, isVideo && s.videoWrapper)} key="imageWrapper" id={`${props.id}GalleryImageWrapper`}>
						{shouldShowControls && (
							<div
								class={joinClasses(
									s.arrows,
									showMobileArrows && s.mobileArrows,
									!hasDownloads && s.noDownloads,
									hideArrowsMobile && s.hideArrowsMobile,
									hideArrowsDesktop && s.hideArrowsDesktop
								)}
								key="arrows"
							>
								{this.renderArrow('leftArrow', -1)}
								{this.renderArrow('rightArrow', 1)}
							</div>
						)}
						<div class={s.contentWrapper} ref={(ref) => (this.contentWrapper = ref)}>
							{this.renderContent(activeImage, isVideo)}
						</div>
						{loading && this.renderImageLoader()}
						<div class={s.bottomWrapper} key="bottomWrapper">
							<div class={s.bottom} key="bottom">
								<Quote class={s.quoteIcon} />
								{/* {shouldShowControls && this.renderNavDots(images, activeImage.key)} */}
								{activeImage.message && activeImage.name && activeImage.role && (
									<Transition
										duration={transitionDuration}
										class={joinClasses(s.annotationTransitionContainer, direction && s[`${direction == -1 ? 'left' : 'right'}SlideTransition`])}
										enteringClass={s.annotationTransitionEntering}
										leavingClass={s.annotationTransitionLeaving}
										visibleClass={s.annotationTransitionVisible}
									>
										<div class={s.annotation}>
											<h2 class={s.message}>{activeImage.message}</h2>
											<p class={s.name}>{activeImage.name}</p>
											<p class={s.role}>{activeImage.role}</p>
										</div>
									</Transition>
								)}
								{hasExtraActions && (
									<div class={s.extraActions}>
										{canShare && this.renderShare(isVideo, shareMetaOverrides)}
										{!iosChromeGif &&
											this.renderDownloadButtons(activeImage, canDownloadAll, canDownloadSingle, customDownloadAll, fontStyles, isVideo)}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				{this.renderOverlayedContent()}
			</div>
		);
	}

	renderNavDots(images, activeKey) {
		// const navDotsAria = accessNested(this.props, 'appData.copy.accessibilityCopy.$NAV_DOTS_ARIA');

		return (
			<div class={s.navDots}>
				{images.map((img, index) => {
					const activeDot = activeKey == img.key;
					const isFirst = index === 0;
					const isLast = index === images.length - 1;
					let { direction = 1 } = this.state;
					if (images.length === 2 && activeKey == 0) {
						direction = -1;
					}

					return (
						<div
							class={joinClasses(s.dotBtn, s.pointer)}
							onClick={() => this.changeActiveImage(img)}
						// key={img.key}
						// ariaLabel={navDotsAria.replace('<number>', img.order)}
						>
							<div class={joinClasses({ s, dot: true, activeDot })} />
						</div>
					);
				})}
			</div>
		);
	}

	render(props) {
		const base = super.render(props);
		if (this.isASpotlightPage) {
			return this.renderSpotlight(props);
		} else if (this.isAGalleryPage) {
			const activeImage = this.getActiveImage();
			const { swipeToChange } = this.state;
			const transitionDuration = swipeToChange ? 0 : TRANSITION_DURATION;
			let bottom = findInVNode(base, `.${s.bottom}`);


			const titleAndDescription = (

				<Transition duration={transitionDuration} class={s.annotationTransitionContainer} leavingClass={s.annotationTransitionLeaving}>

					<div key={activeImage.title}>
						{activeImage.title && <h2 class={s.slideTitle}>{activeImage.title}</h2>}
						{activeImage.description && <p class={s.slideDescription}>{activeImage.description}</p>}
					</div>
				</Transition>


			);
			bottom.children.push(titleAndDescription);


		}
		return base;
	}

}
